/*
  AuthenticatedRouting
  Defines and handles routes that require authentication to access
*/

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BlankLayoutComponent } from '@app/layout/blank-layout';

import { MembershipEntityResolver } from '@resolver/membership-entity/membership-entity.resolver';
import { AuthenticatedComponent } from './authenticated.component';
import { EditorViewComponent } from './editor-view/editor-view.component';
import { PreviewFormComponent } from './preview-form/preview-form.component';
import { ShareWizardComponent } from './share-wizard/share-wizard.component';
import { ViewDocumentComponent } from './view-document/view-document.component';

const routes: Routes = [
  {
    children: [
      { component: EditorViewComponent, data: { type: 'document' }, path: 'builder/document/:id' },
      { component: EditorViewComponent, data: { type: 'rtd' }, path: 'builder/rtd/:id' },
      { component: EditorViewComponent, data: { type: 'form' }, path: 'builder/form/:id' },
      {
        children: [
          {
            component: ShareWizardComponent,
            path: 'share',
          },
          {
            component: ShareWizardComponent,
            path: 'e/:membership_entity_id/share',
            resolve: {
              membershipEntity: MembershipEntityResolver
            }
          },
          {
            component: ViewDocumentComponent ,
            path: 'builder/document/:id/view'
          },
          {
            component: PreviewFormComponent,
            data: { builder_preview: true },
            path: 'builder/rtd/:id/preview'
          },
          {
            component: PreviewFormComponent,
            data: { builder_preview: true },
            path: 'builder/form/:id/preview'
          }
        ],
        component: BlankLayoutComponent,
        path: ''
      }
    ],
    component: AuthenticatedComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class AuthenticatedRoutingModule {}
